import React, { useState } from 'react';

class Alert extends React.Component {
  state = {
    playSiren: true
  };

  render() {
    const { type } = this.props;
    if (!type) return null;
    return (
      <div className={`alert-bell alert-bell-${type} ${this.state.playSiren && 'alert-bell-animation'}`} onClick={() => this.setState({ playSiren: !this.state.playSiren })}>
        <span className='fa fa-bell' />
        {this.state.playSiren && <audio id="alertPlayer" controls autoPlay hidden loop>
          {/* <source src="http://hydrology.gov.np/siren.ogg" type="audio/ogg" /> */}
          {/* <source src="http://hydrology.gov.np/siren.mp3" type="audio/mpeg" /> */}
          <source src="./siren/siren.ogg" type="audio/ogg" />
          <source src="./siren/siren.mp3" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>}
      </div>
    )
  }
}

export default Alert;


// WEBPACK FOOTER //
// ./src/component/common/Alert.js